import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as dayjs from 'dayjs';
import { DataService } from 'src/app/services/data.service';
import { ModalMakerService } from 'src/app/services/modal-maker.service';

@Component({
  selector: 'app-room-reservation',
  templateUrl: './room-reservation.component.html',
  styleUrls: ['./room-reservation.component.scss'],
})

export class RoomReservationComponent implements OnInit {

  checkIn: string = dayjs(new Date()).format('YYYY-MM-DD');
  checkOut: string = dayjs(new Date()).add(4, 'day').format('YYYY-MM-DD');
  adult = 1;
  children = 0;

  urlLink: string = null;

  constructor(
    private mdlctrl: ModalController,
    public dataServ: DataService,
    private modalServ: ModalMakerService
  ) { }

  ngOnInit() { }

  async close() {
    await this.mdlctrl.dismiss();
  }

  openReservation() {
    // eslint-disable-next-line max-len
    this.modalServ.openLink(`https://reservations.travelclick.com/102378?datein=${dayjs(this.checkIn).format('MM/DD/YYYY')}&dateout=${dayjs(this.checkOut).format('MM/DD/YYYY')}&rooms=1${this.children > 0 ? '&children=' + this.children : ''}&adults=${this.adult}&languageid=1`);
  }
}
